/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum AutorizacaoGuiaFormAliases {
  ACTION_PRINT = 'action-print',
  CONTEXTUAL_BAR_0 = 'contextual-bar-0',
  FETCH_CONSULTA = 'fetch-consulta',
  FETCH_CONSULTA_DIAGNOSTICOS = 'fetch-consulta-diagnosticos',
  FIELD_0 = 'field-0',
  FIELD_1 = 'field-1',
  FIELD_2 = 'field-2',
  FIELD_3 = 'field-3',
  FIELD_4 = 'field-4',
  FIELD_5 = 'field-5',
  FIELD_6 = 'field-6',
  FIELD_CD_GUIA = 'field-cdGuia',
  FIELD_CD_SENHA = 'field-cdSenha',
  FIELD_CID = 'field-cid',
  FIELD_DS_CARATER_INTERNACAO = 'field-dsCaraterInternacao',
  FIELD_DS_CBO_SAUDE = 'field-dsCboSaude',
  FIELD_DS_CNES = 'field-dsCnes',
  FIELD_DS_ESPECIALIDADE = 'field-dsEspecialidade',
  FIELD_DS_REGIME_INTERNACAO = 'field-dsRegimeInternacao',
  FIELD_DS_TIPO_ACOMODACAO = 'field-dsTipoAcomodacao',
  FIELD_DS_TIPO_ATEND_TISS = 'field-dsTipoAtendTiss',
  FIELD_DS_TIPO_ATENDIMENTO_ODONTO = 'field-dsTipoAtendimentoOdonto',
  FIELD_DS_TIPO_CONSULTA = 'field-dsTipoConsulta',
  FIELD_DS_TIPO_GUIA = 'field-dsTipoGuia',
  FIELD_DS_TIPO_INTERNACAO = 'field-dsTipoInternacao',
  FIELD_DT_INTERNACAO_SUGERIDA = 'field-dtInternacaoSugerida',
  FIELD_DT_NASC_RECEM_NASCIDO = 'field-dtNascRecemNascido',
  FIELD_DT_SOLICITACAO = 'field-dtSolicitacao',
  FIELD_DT_VALIDADE_SENHA = 'field-dtValidadeSenha',
  FIELD_IE_STATUS = 'field-ieStatus',
  FIELD_LIST_CID = 'field-list-cid',
  FIELD_NM_BENEFICIARIO = 'field-nmBeneficiario',
  FIELD_NM_MEDICO_SOLIC = 'field-nmMedicoSolic',
  FIELD_NM_PRESTADOR = 'field-nmPrestador',
  FIELD_NM_RECEM_NASCIDO = 'field-nmRecemNascido',
  FIELD_NR_CGC_CPF = 'field-nrCgcCpf',
  FIELD_NR_PROTOCOLO1 = 'field-nrProtocolo1',
  FIELD_QT_DIA_AUTORIZADO = 'field-qtDiaAutorizado',
  FIELD_QT_DIA_SOLICITADO = 'field-qtDiaSolicitado',
  FIELDSET_0 = 'fieldset-0',
  FIELDSET_CID_ASDF = 'fieldset-cid--asdf',
  FIELDSET_EXTERNA = 'fieldset-externa',
  FIELDSET_INTERNACAO = 'fieldset-internacao',
  FIELDSET_RECEM_NASCIDO = 'fieldset-recem-nascido',
  FORM_GUIA = 'form-guia',
  INPUT_0 = 'input-0',
  INPUT_1 = 'input-1',
  INPUT_2 = 'input-2',
  INPUT_3 = 'input-3',
  PANEL_AUTORIZACAO_GUIA_FORM = 'panel-autorizacao-guia-form',
  PANEL_CID = 'panel-cid',
  REPEATER_AUTHORIZATION_DIAGNOSIS = 'repeater-authorization-diagnosis',
  TEXT = 'text',
  TEXT_0 = 'text-0',
  TEXT_1 = 'text-1',
  TEXT_2 = 'text-2',
  TEXT_3 = 'text-3',
  TEXT_4 = 'text-4',
  TEXT_5 = 'text-5',
  TEXT_CD_GUIA = 'text-cdGuia',
  TEXT_CD_SENHA = 'text-cdSenha',
  TEXT_CD_USUARIO_PLANO = 'text-cdUsuarioPlano',
  TEXT_CID = 'text-cid',
  TEXT_DS_CARATER_INTERNACAO = 'text-dsCaraterInternacao',
  TEXT_DS_CBO_SAUDE = 'text-dsCboSaude',
  TEXT_DS_CNES = 'text-dsCnes',
  TEXT_DS_ESPECIALIDADE = 'text-dsEspecialidade',
  TEXT_DS_REGIME_INTERNACAO = 'text-dsRegimeInternacao',
  TEXT_DS_TIPO_ACOMODACAO = 'text-dsTipoAcomodacao',
  TEXT_DS_TIPO_ATEND_TISS = 'text-dsTipoAtendTiss',
  TEXT_DS_TIPO_ATENDIMENTO_ODONTO = 'text-dsTipoAtendimentoOdonto',
  TEXT_DS_TIPO_CONSULTA = 'text-dsTipoConsulta',
  TEXT_DS_TIPO_GUIA = 'text-dsTipoGuia',
  TEXT_DS_TIPO_INTERNACAO = 'text-dsTipoInternacao',
  TEXT_NM_BENEFICIARIO = 'text-nmBeneficiario',
  TEXT_NM_MEDICO_SOLIC = 'text-nmMedicoSolic',
  TEXT_NM_PRESTADOR = 'text-nmPrestador',
  TEXT_NM_RECEM_NASCIDO = 'text-nmRecemNascido',
  TEXT_NR_CGC_CPF = 'text-nrCgcCpf',
  TEXT_QT_DIA_AUTORIZADO = 'text-qtDiaAutorizado',
  TEXT_QT_DIA_SOLICITADO = 'text-qtDiaSolicitado',
}
export { AutorizacaoGuiaFormAliases };
